var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"contextMenu",staticClass:"ctx-menu-container",style:(_vm.ctxStyle),attrs:{"id":_vm.id},on:{"click":function($event){$event.stopPropagation();},"contextmenu":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"ctx open",staticStyle:{"background-color":"transparent"}},[_c('ul',{staticClass:"ctx-menu",class:{
          'ctx-menu-right': _vm.align==='right',
          'ctx-menu-left': _vm.align==='left'
        },attrs:{"role":"menu"}},[_vm._t("default")],2)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71aab7b4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/context-menu/index.vue
// module id = 437
// module chunks = 1